angular.module("ainapp")
    .controller("listofoutstandingCreditController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "List Of Outstanding Credit";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.ParentList = [];
            MainService.GetVendorParentList().then(function (response) {
                $scope.ParentList = response.data;
            });

            $scope.Branches = [];
            MainService.BranchesInDropdown().then(function (response) {
                var temp = {
                    Id: "",
                    Name: "All",
                }
                $scope.Branches = response.data;
                $scope.Branches.push(temp);
            }, function (err) {
                toastr.error("Network Error");
            })


            $scope.Init = function () {


                var startdate = new Date(new Date().getFullYear(), 0, 1);


                $scope.filter = {
                    BranchId: "",
                    Keyword: "",
                    AccountParentId: "",
                    CustomerIds: [],
                    FromDate: startdate,
                    ToDate: new Date(),
                }

                $scope.load = false;
                $scope.isFilter = false;


                $scope.Columns = [
                    {
                        field: "INVNo",
                        title: "Doc No #",
                        width: "100px",
                        },
                    {
                        field: "INVType",
                        title: "Type",
                        width: "100px",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: "120px",
                        },
                    {
                        field: "BillNo",
                        title: "PO No",
                        width: "100px",
                        },
                    {
                        field: "SupplierBillNo",
                        title: "Others",
                        template: "<span> Sup bill No :  {{dataItem.SupplierBillNo}}<span/> <span> Sup qtn No :  {{dataItem.SupplierQtnNo}}<span/> <span>Enq No :  {{dataItem.EnquiryNo}}<span/><span>Order No :  {{dataItem.OrderNo}}<span/>",
                        width: "100px",
                        },
                    {
                        field: "CustomerPONo",
                        title: "Others",
                        template: "<span> Customer PO No :  {{dataItem.CustomerPONo}}<span/> <span> Sup PO No :  {{dataItem.SupplierPONO}}<span/> <span>Bill Date :  {{dataItem.BillDate | date : 'dd/MM/yyyy'}}<span/><span>Delivery Date :  {{dataItem.DeliveryDate | date : 'dd/MM/yyyy'}}<span/>",
                        width: "100px",
                        },
//                    {
//                        field: "DueDate",
//                        title: "Due Date",
//                        template: '<span>{{dataItem.DueDate | date: "dd/MM/yyyy"}}</span>',
//                        width: "120px",
//                        },
                    {
                        field: "Account.Name",
                        title: "Account",
                        width: "250px",
                                            },

                    {
                        field: "TotalAmount",
                        title: "Total Amount",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalAmount, 'n')#</div>",
                        width: "100px",
                        headerTemplate: kendo.template("<div class='headerright'>Total Amount</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },
                    {
                        field: "TotalPaid",
                        title: "Total Paid",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalPaid, 'n')#</div>",
                        width: "100px",
                        headerTemplate: kendo.template("<div class='headerright'>Total Paid</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },
                    {
                        field: "BalanceAmount",
                        title: "Balance Amount",
                        width: "100px",
                        aggregates: ["sum"],
                        //footerTemplate: "#=sum#",
                        template: "<div style='text-align: right'>#=kendo.toString(BalanceAmount, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Balance Amount</div>"),
                        groupFooterTemplate: "#=kendo.toString(sum, '0.00')#",
                        footerTemplate: "#=kendo.toString(sum, '0.00')#",
                                            },

                    {
                        field: "CumulativeBalance",
                        title: "Cumulative Balance",
                        width: "100px",
                        template: "<div style='text-align: right'>#=kendo.toString(CumulativeBalance, 'n')#</div>",
                        headerTemplate: kendo.template("<div class='headerright'>Cumulative Balance</div>")
                                            }]

                $scope.CostCenters = [];
                MainService.CostCentersInReortVoucher("Bill Analysis").then(function (response) {
                    $scope.CostCenters = response.data;

                    angular.forEach($scope.CostCenters, function (e) {
                        var field = e.CostCenter.Name.replace(/ /g, '');
                        field = field.replace('&', '');
                        field = field.replace('/', '');
                        field = field.replace('.', '');

                        var clm = {
                            title: e.CostCenter.Name,
                            field: "CC" + field,
                            //  template: "<a ng-repeat='cc in dataItem.CreditNoteSRCosts' ng-click='temp(dataItem, $event)' >{{cc.CostCenterName}}  </a>",
                            width: '100px',
                            //ng-if='cc.ParentId == $scope.CostCenters[i].CostCenterId'
                        }
                        $scope.Columns.push(clm);
                    })

                    $scope.loadKendo();
                    $('#filterModal').modal('show');
                });


            }
            $scope.Init();



            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.accountInAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };


            $scope.loadKendo = function () {

                $scope.KendoSource = new kendo.data.DataSource({
                    batch: true,
                    transport: {
                        read: function (o) {

                            if ($scope.isFilter) {


                                o.data.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                                o.data.FromDay = $scope.filter.FromDate.getDate();
                                o.data.FromYear = $scope.filter.FromDate.getFullYear();

                                o.data.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                                o.data.ToDay = $scope.filter.ToDate.getDate();
                                o.data.ToYear = $scope.filter.ToDate.getFullYear();

                                o.data.CustomerIds = $scope.filter.CustomerIds;
                                o.data.Keyword = $scope.filter.Keyword;
                                o.data.ProductId = $scope.filter.ProductId;
                                o.data.BranchId = $scope.filter.BranchId;
                                o.data.AccountParentId = $scope.filter.AccountParentId;

                                MainService.BillWiseOutStandingCreditReport(o.data).then(function (response) {
                                    $scope.GlData = response.data.Data;
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("NetworkError");
                                })
                            } else {
                                o.success({
                                    Data: []
                                });
                            }



                        },

                    },
                    change: function (data) {
                        if (data.items.length > 0) {
                            console.log(data);
                            var arr = [];
                            angular.forEach($scope.CostCenters, function (e) {
                                var field = e.CostCenter.Name.replace(/ /g, '');
                                field = field.replace('&', '');
                                field = field.replace('/', '');
                                field = field.replace('.', '');
                                arr.push('CC' + field);
                            })
                            angular.forEach(data.items[0].items, function (e) {
                                angular.forEach(arr, function (ar) {

                                    angular.forEach(e.BillWiseCosts, function (a) {

                                        var afield = a.ParentName.replace(/ /g, '');
                                        afield = afield.replace('&', '');
                                        afield = afield.replace('/', '');
                                        afield = afield.replace('.', '');
                                        afield = "CC" + afield;

                                        if (afield == ar) {
                                            e[ar] = a.CostCenterName;
                                        }
                                    })


                                })
                            })
                        }
                    },
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                INVNo: {
                                    type: "string",
                                    editable: false,
                                },
                                INVType: {
                                    type: "string",
                                    editable: false,
                                },

                                "Account.Name": {
                                    type: "string",
                                    editable: false,
                                },
                                INVID: {
                                    type: "number",
                                    editable: false,
                                },
                                TotalAmount: {
                                    type: "number",
                                    editable: false,
                                },
                                TotalPaid: {
                                    type: "number",
                                    editable: false,
                                },
                                BalanceAmount: {
                                    type: "number",
                                    editable: false,
                                },
                                Date: {
                                    type: "date",
                                    editable: false,
                                },
                                BillDate: {
                                    type: "date",
                                    editable: false,
                                },
                                //                            DueDate: {
                                //                                type: "date",
                                //                                editable: false,
                                //                            },
                                BillNo: {
                                    type: "string",
                                    editable: false,
                                },

                                Amount: {
                                    type: "number",
                                    editable: false,
                                },

                                CumulativeBalance: {
                                    type: "number",
                                    editable: false,
                                },
                                SupplierBillNo: {
                                    type: "string",
                                    editable: false,
                                },
                                SupplierQtnNo: {
                                    type: "string",
                                    editable: false,
                                },
                                EnquiryNo: {
                                    type: "string",
                                    editable: false,
                                },
                                OrderNo: {
                                    type: "string",
                                    editable: false,
                                },
                                CustomerPONo: {
                                    type: "string",
                                    editable: false,
                                },
                                SupplierPONO: {
                                    type: "string",
                                    editable: false,
                                },
                                DeliveryDate: {
                                    type: "date",
                                    editable: false,
                                }




                            }
                        }
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    // pageSize: 20,

                    group: [{
                        field: "Account.Name",
                        aggregates: [
                            {
                                field: "TotalAmount",
                                aggregate: "sum"
                        },
                            {
                                field: "TotalPaid",
                                aggregate: "sum"
                        },
                            {
                                field: "BalanceAmount",
                                aggregate: "sum"
                        },
                        ]
                    }],
                    aggregate: [
                        {
                            field: "TotalAmount",
                            aggregate: "sum"
                        },
                        {
                            field: "TotalPaid",
                            aggregate: "sum"
                        },
                        {
                            field: "BalanceAmount",
                            aggregate: "sum"
                        },
                    ],
                });

                $scope.KendoGridOptions = {


                    editable: false,
                    pageable: true,
                    toolbar: ["excel"],
                    height: 700,
                    resizable: true,
                    dataSource: $scope.KendoSource,
                    pageSize: 20,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    sortable: true,
                    scrollable: true,
                    filterable: true,
                    groupable: false,
                    columnMenu: {
                        filterable: false,
                        filterable: true,
                    },


                    columns: $scope.Columns,
                };

            }

            $scope.OpenFilter = function () {
                $('#filterModal').modal('show');
            }

            $scope.GetReport = function () {
                $scope.isFilter = true;
                $('#filterModal').modal('hide');
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.Refresh = function () {
                $scope.Init();
                $scope.isFilter = true;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


            $scope.print2 = function () {

                $scope.filter.FromMonth = $scope.filter.FromDate.getMonth() + 1;
                $scope.filter.FromDay = $scope.filter.FromDate.getDate();
                $scope.filter.FromYear = $scope.filter.FromDate.getFullYear();

                $scope.filter.ToMonth = $scope.filter.ToDate.getMonth() + 1;
                $scope.filter.ToDay = $scope.filter.ToDate.getDate();
                $scope.filter.ToYear = $scope.filter.ToDate.getFullYear();

                MainService.PrintBillWiseOutStandingReport($scope.filter).then(function (response) {
                    if (response.data != null) {
                        $window.open(config.basePath + "/Reports/" + response.data, "_blank");
                    } else {
                        toastr.error("Network Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                })
            }

            $scope.print = function () {

                //                var grid = $("#Kendo-Grid").data("kendoGrid");
                //                var allRows = grid.dataSource.data();
                //                console.log(allRows);

                var Fromdate = $scope.extractDate($scope.filter.FromDate);
                var ToDate = $scope.extractDate($scope.filter.ToDate);

                var array = [];
                angular.forEach($scope.GlData, function (e) {
                    var date = new Date(e.Date);
                    date = $scope.extractDate(date);

                    var temp = {
                        AccountId: e.AccountId,
                        BillWiseId: e.Id,
                        //BillWiseDetailId: e.BillWiseDetailId,
                        Title: "List Of Outstanding Debit",
                        AccountName: e.Account.Name,
                        AccountCode: e.Account.AccountCode,
                        Type: e.Type,
                        Date: $scope.extractDate(e.Date),
                        VoucherNo: e.INVNo,
                        PONo: e.BillNo,
                        SupBillNo: e.SupplierBillNo,
                        SupQtnNo: e.SupplierQtnNo,
                        EnqNo: e.EnquiryNo,
                        OrderNo: e.OrderNo,
                        CusPoNo: e.CustomerPONo,
                        SupPoNo: e.SupplierPONO,
                        DueDate: e.DueDate != null ? $scope.extractDate(e.DueDate) : "",
                        //SubAccountName: e.SubAccountName,
                        BillNo: e.BillNo,
                        BillDate: e.BillDate != null ? $scope.extractDate(e.BillDate) : "",
                        TotalAmount: e.TotalAmount,
                        TotalPaid: e.TotalPaid,
                        BalanceAmount: e.BalanceAmount,
                        CumilativeBalance: e.CumulativeBalance,
                        DateFrom: Fromdate,
                        DateTo: ToDate,
                    };
                    array.push(temp);
                });

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.PrintTempBillWiseOutstanding(array).then(
                    function (response) {
                        if (response.data != null) {
                            $window.open(
                                config.basePath + "/Reports/" + response.data,
                                "_blank"
                            );
                        } else {
                            toastr.error("Network Error");
                        }
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    },
                    function (err) {
                        toastr.error("Network Error");
                        $scope.Load = false;
                        $.LoadingOverlay("hide");
                    }
                );
            };




        }])
